import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CoreComponent} from '../../core/core.component';
import { HigherEducationInstitutionType } from './higher-education-institution-type';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {NgForm} from '@angular/forms';
import {HigherEducationInstitutionTypesService} from '../higher-education-institution-types.service';
import {ActivatedRoute} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
declare var $: any;
@Component({
  selector: 'app-higher-education-institution-type',
  templateUrl: './higher-education-institution-type.component.html',
  styleUrls: ['./higher-education-institution-type.component.scss']
})
export class HigherEducationInstitutionTypeComponent extends CoreComponent<HigherEducationInstitutionType> {

  @Input() item: HigherEducationInstitutionType = new HigherEducationInstitutionType();
  validated= false;
  @ViewChild('ngForm', { static: false }) public ngForm: NgForm;
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: HigherEducationInstitutionTypesService,
              protected gaService: GoogleAnalyticsService,
              public route: ActivatedRoute,public activeModal: NgbActiveModal, private matSnackBar: MatSnackBar) {
    super(servicesService,route);
  }

  onSubmit() {

    if (!this.ngForm.valid) {
      this.validated = true;
      $('html, body').animate({
        scrollTop: 0
      }, 1000, function() {
      });
      return;
    } else {
      this.blockUI.start();
      this.servicesService.save(this.item).subscribe((item: HigherEducationInstitutionType) => {
        this.blockUI.stop();
        this.activeModal.close();
        this.item = item;
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        this.matSnackBar.open(error.error.message, 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      });
    }

  }

}
